import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class LogoMarquee extends UcoastEl {
	static htmlSelector = 'logo-marquee'

	private viewport?: HTMLElement
	private track?: HTMLElement
	private lists: HTMLElement[] = []
	private resizeObserver?: ResizeObserver

	override connectedCallback(): void {
		super.connectedCallback()
		this.viewport = q.os('.logo-marquee__viewport', this)
		this.track = q.os('.logo-marquee__track', this)
		this.lists = Array.from(q.ol('.logo-marquee__list', this) ?? [])

		const primaryList = this.lists[0]
		if (!this.viewport || !this.track || !primaryList) return

		this.syncListCount()
		this.resizeObserver = new ResizeObserver(this.syncListCount)
		this.resizeObserver.observe(this.viewport)
		this.resizeObserver.observe(primaryList)
	}

	override disconnectedCallback(): void {
		this.resizeObserver?.disconnect()
		this.resizeObserver = undefined
		if (this.track) {
			this.lists.forEach((list) => this.track?.append(list))
			this.style.setProperty(
				'--logo-marquee-loop-count',
				String(this.lists.length)
			)
		}
		super.disconnectedCallback()
	}

	private syncListCount = (): void => {
		const primaryList = this.lists[0]
		if (!this.viewport || !this.track || !primaryList) return

		const listWidth = primaryList.getBoundingClientRect().width
		const viewportWidth = this.viewport.getBoundingClientRect().width
		if (listWidth <= 0 || viewportWidth <= 0) return

		const requiredListCount = Math.min(
			this.lists.length,
			Math.max(2, Math.ceil(viewportWidth / listWidth) + 1)
		)

		this.lists.forEach((list, index) => {
			if (index < requiredListCount) {
				if (list.parentElement !== this.track) this.track?.append(list)
			} else {
				list.remove()
			}
		})
		this.style.setProperty(
			'--logo-marquee-loop-count',
			String(requiredListCount)
		)
	}
}
